import * as types from "../Actions/Types";
import { IStore } from "../Models/IStore";
import { ITerritory, IUser } from "../Models/Models";

export interface IUserManagementStore {
  franchiseeStoreData: Array<IStore>;
  franchiseeTerritoryData: Array<ITerritory>;
}
const userManagementDefaultState: IUserManagementStore = {
    franchiseeStoreData: [],
    franchiseeTerritoryData: [],
};

export const userManagement = (
    userManagementStore: IUserManagementStore = { ...userManagementDefaultState },
    action
): IUserManagementStore => {
    switch (action.type) {
        case types.GET_USER_FRANCHISEE_STORE_INFORMATION_SUCCESS:
            // common.radio.broadcast
            return Object.assign({}, userManagementStore, {
                franchiseeStoreData: action.response.data,
            });

        case types.GET_USER_FRANCHISEE_TERRITORY_INFORMATION_SUCCESS:
            return Object.assign({}, userManagementStore, {
                franchiseeTerritoryData: action.response.data,
            });

        case types.REMOVE_STORE_FROM_FRANCHISEE_USER_SUCCESS:
            const franchiseeStoreDataCopy = [
                ...userManagementStore.franchiseeStoreData,
            ];
            for (let i = 0; i < franchiseeStoreDataCopy.length; i++) {
                if (franchiseeStoreDataCopy[i].id === action.response.storeID) {
                    franchiseeStoreDataCopy.splice(i, 1);
                    // update SCOUT
                    const scoutContext = (window as any).scout.context;
                    scoutContext.getFranchiseeStores(action.response.userID);
                    break;
                }
            }

            return Object.assign({}, userManagementStore, {
                franchiseeStoreData: franchiseeStoreDataCopy,
            });

        case types.REMOVE_TERRITORY_FROM_FRANCHISEE_USER_SUCCESS:
            const franchiseeTerritoryDataCopy = [
                ...userManagementStore.franchiseeTerritoryData,
            ];
            for (let i = 0; i < franchiseeTerritoryDataCopy.length; i++) {
                if (franchiseeTerritoryDataCopy[i].id === action.response.territoryID) {
                    franchiseeTerritoryDataCopy.splice(i, 1);
                    // update SCOUT
                    const scoutContext = (window as any).scout.context;
                    scoutContext.getFranchiseeTerritories(action.response.userID);
                    break;
                }
            }

            return Object.assign({}, userManagementStore, {
                franchiseeTerritoryData: franchiseeTerritoryDataCopy,
            });

            // FAILURE
        case types.GET_USER_FRANCHISEE_STORE_INFORMATION_FAILURE:
        case types.GET_USER_FRANCHISEE_TERRITORY_INFORMATION_FAILURE:
        case types.REMOVE_STORE_FROM_FRANCHISEE_USER_FAILURE:
        case types.REMOVE_TERRITORY_FROM_FRANCHISEE_USER_FAILURE:
        case types.GET_TERRITORY_TYPES_FAILURE:
            console.log(action);

        default:
            return userManagementStore;
    }
};
